var _style, _polygon, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFullscreenEnter = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-40 -40 350 350",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    polygon {\n      stroke-width: 4px;\n      stroke: #000;\n      fill: currentColor;\n  ")), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    id: "angle",
    points: "0,0 90,0 90,20 20,20 20,90, 0,90"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-270 0 0)                translate(0 -270)                "
  }, /*#__PURE__*/React.createElement("use", {
    href: "#angle"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-180 0 0)                translate(-270 -270)                "
  }, /*#__PURE__*/React.createElement("use", {
    href: "#angle"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-90 0 0)                translate(-270 0)                "
  }, /*#__PURE__*/React.createElement("use", {
    href: "#angle"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFullscreenEnter);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/fullscreen-enter.ab7ba30177c7b8a53166478d224c9e8a.svg";